import GetUrls from 'ts/enums/Url'
import { PriceLevel } from 'ts/types'
import useModalStore from 'store/modal'
import { CheckBox, Input } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const PriceLevelAddPage = () => {
const Url = GetUrls();

  const params = useModalStore((state) => state.params) as PriceLevel
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form

  if (params) {
    setValue('productPriceLevelId', params.productPriceLevelId)
  }

  return (
    <ModalForm
      config={{
        url: Url.postPriceLevel,
        method: params ? 'PUT' : 'POST'
      }}
      title={`${params ? 'Edit ' : 'Add ' }Price Level`}
      description='Add or edit a Price Level'
    >
      {params ? (
        <Input defaultValue={params.productPriceLevelId} label="ID" disabled />
      ) : null}

      <CheckBox
        defaultChecked={params?.flActive || false}
        label="Active"
        {...register('flActive')}
      />
      <Input
        defaultValue={params?.name || ''}
        label="Price Level Name"
        {...register('name', { required: true })}
      />
    </ModalForm>
  )
}

export default PriceLevelAddPage
